import type { SelectHTMLAttributes } from 'react';
import { ChevronDown } from 'lucide-react';

interface SelectBoxProps extends SelectHTMLAttributes<HTMLSelectElement> {
  /** `text` drops the border and background for inline sentences */
  variant?: 'default' | 'text';
  /** Applied to the wrapper, so widths go here */
  className?: string;
}

const SELECT_CLASS = {
  default: 'h-9 w-full rounded-md border border-input bg-background pl-2 pr-8 text-sm truncate',
  text: 'h-auto w-full border-0 bg-transparent p-0 pr-5 text-xs text-foreground truncate',
};

/** Native select with a fixed-position chevron so text never runs under it. */
export function SelectBox({ variant = 'default', className = '', children, ...props }: SelectBoxProps) {
  const wrapper = variant === 'text' ? 'inline-block' : 'block';
  return (
    <span className={`relative ${wrapper} ${className}`}>
      <select {...props} className={`appearance-none disabled:opacity-60 ${SELECT_CLASS[variant]}`}>{children}</select>
      <ChevronDown aria-hidden="true" className={`pointer-events-none absolute top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground ${variant === 'text' ? 'right-0' : 'right-2'}`} />
    </span>
  );
}
